



















export default {
    name: "Modal",
    props: {
        showModal: Boolean,
    },
    methods: {
        closeDialog: function () {
            this.$emit("close-modal");
        },
        getLevel: function () {
            let level = 0;
            let parent = this.$parent;
            while (parent) {
                if (parent.$options.name === "portalTarget") {
                    level++;
                }
                parent = parent.$parent;
            }
            return level;
        },
    },
};
